exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n}\n\n#header{\n  background: rgb(3, 72, 73);\n  background-image: url(/threekit_logo_inverted.svg);\n  background-repeat: no-repeat;\n  background-size: auto 30px;\n  background-position-y: center;\n  background-position-x: 30px;\n}\n\n.App-link {\n  color: #09d3ac;\n}", ""]);

